import { Button, Container, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'

import Can from '../../Layout/Can/Can.jsx'
import RolesDialog from '../Dialogs/Dialog.jsx'
import ListStandard from '../Lists/ListStandard.jsx'

const Users = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Container
      maxWidth="lg"
      sx={{ py: 3 }}
    >
      <Can action="roles_r">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h2">{t('common.roles')}</Typography>
          </Stack>

          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsOpen(true)}
          >
            {t('roles.add')}
          </Button>
        </Stack>
        <ListStandard />
      </Can>

      {isOpen && <RolesDialog isOpen={isOpen} setIsOpen={setIsOpen} />}
    </Container >
  )
}

export default Users
